import React from "react";
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import {FaSearch} from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";

const BtnNoir = styled.a`
font-family: "Assistant", sans-serif;
letter-spacing: 0.06rem;
text-decoration: none;
border: none;
background: #000;
text-align: center;
display: inline-block; 
align-items: center; 
justify-content: center;
align-items: center;
width: ${props => props.width || "auto"};
margin: ${props => props.margin || "auto"};
padding: ${props => props.padding || "20px"};
min-width: 180px;
position: relative;
cursor: pointer;
color: #fff; 
font-size: 17px;
transition: all .2s ease-out;
  &:hover {
    transform: scale(1.1);
    text-decoration: none;
    color: #fff; 
}

@media screen and (max-width: 576px) {
    width: ${props => props.widthMob || "100%"};
    padding: 15px;
    margin: auto;
}
`;


export default function LinkNoirST(props) {


    return <BtnNoir className={props.className} margin={props.margin}  padding={props.padding} width={props.width} widthMob={props.widthMob} href={props.href}>{props.lib}</BtnNoir>   


}